import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { trending } from "@/mocks/doujinshi";

const filters = ["全部", "漫画本", "插画画集", "四格漫画", "网络条漫", "短篇合集"];

function formatViews(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;
}

export default function Trending() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? trending : trending.filter((t) => t.format === active);

  return (
    <section id="trending" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="本周热门"
          title="大家都在读的打包作品"
          desc="实时盘点浏览与收藏最高的人气同人志，漫画本、画集、四格、条漫一网打尽。"
        />

        <div className="mb-8 flex flex-wrap items-center justify-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`rounded-full px-4 py-1.5 text-xs transition-colors ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((item) => (
            <a
              key={item.id}
              href="#about"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:border-secondary-200"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} · ${item.format} 打包作品封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] text-background-50 backdrop-blur">
                  {item.format}
                </span>
                {item.hot && (
                  <span className="absolute right-3 top-3 grid h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className="ri-fire-fill text-sm"></i>
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">
                  {item.circle} · {item.chapters}话打包
                </p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-3 flex items-center gap-4 border-t border-background-200 pt-3 text-[11px] text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(item.views)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-line"></i>
                    {formatViews(item.likes)}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600">
                    整本阅读 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}